import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export default (theme: Theme) =>
  StyleSheet.create({
    // Header personnalisé
    customHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.white,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    backButton: {
      padding: theme.spacing.sm,
      marginRight: theme.spacing.sm,
    },
    headerContent: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerLeft: {
      position: 'relative',
      marginRight: theme.spacing.md,
    },
    headerAvatar: {
      width: 40,
      height: 40,
      borderRadius: 20,
    },
    onlineIndicator: {
      position: 'absolute',
      bottom: 2,
      right: 2,
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: theme.colors.green,
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    headerInfo: {
      flex: 1,
    },
    headerName: {
      color: theme.colors.secondary,
      marginBottom: 2,
    },
    headerStatus: {
      color: theme.colors.greyBlue,
    },
    headerActions: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerAction: {
      padding: theme.spacing.sm,
      marginLeft: theme.spacing.xs,
    },

    // Messages
    messagesList: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    messagesContent: {
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
    },
    messageContainer: {
      marginBottom: theme.spacing.md,
    },
    receivedMessageWrapper: {
      alignItems: 'flex-start',
    },
    receivedMessageContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      maxWidth: '100%'
    },
    sentMessageWrapper: {
      alignItems: 'flex-end',
    },
    sentMessage: {
      backgroundColor: theme.colors.primary,
      borderRadius: 18,
      borderBottomRightRadius: 4,
      maxWidth: '100%'
    },
    receivedMessage: {
      backgroundColor: theme.colors.white,
      borderRadius: 18,
      borderBottomLeftRadius: 4,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      borderWidth: 1,
      borderColor: theme.colors.greyBlue,
      maxWidth: '100%'
    },
    sentMessageText: {
      color: theme.colors.white,
      fontSize: theme.fontSize.medium,
      padding: theme.spacing.sm,
    },
    receivedMessageText: {
      color: theme.colors.secondary,
      fontSize: theme.fontSize.medium,
      marginBottom: theme.spacing.xs,
    },
    sentMessageTime: {
      color: theme.colors.greyBlue,
      fontSize: theme.fontSize.extraSmall,
      marginTop: theme.spacing.xs,
      alignSelf: 'flex-end',
    },
    sentMessageFooter: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-end',
      gap: theme.spacing.sm,
    },
    readReceipt: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 2,
    },
    receivedMessageTime: {
      color: theme.colors.greyBlue,
      fontSize: theme.fontSize.extraSmall,
      marginTop: theme.spacing.xs,
      marginLeft: theme.spacing.sm,
      alignSelf: 'flex-start',
    },
    messageAvatar: {
      width: 20,
      height: 20,
      borderRadius: 10,
    },
    messageImage: {
      width: 150,
      height: 150,
      borderTopLeftRadius: 18,
      borderTopRightRadius: 18
    },
    messageFooter: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: theme.spacing.xs,
    },

    // Input
    inputContainer: {
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
      borderTopWidth: 1,
      borderTopColor: theme.colors.lightGrey,
      backgroundColor: theme.colors.white,
    },
    textInput: {
      fontSize: theme.fontSize.medium,
      color: theme.colors.secondary,
      minHeight: 36,
      maxHeight: 150,
      paddingHorizontal: theme.spacing.xs,
      paddingVertical: theme.spacing.xs,
    },
    imagePreviewWrapper: {
      alignSelf: 'flex-start',
      marginTop: theme.spacing.sm,
    },
    imagePreview: {
      width: 96,
      height: 96,
      borderRadius: theme.border.medium,
    },
    removeImageIcon: {
      position: 'absolute',
      top: -theme.spacing.sm,
      right: -theme.spacing.sm,
      width: 24,
      height: 24,
      borderRadius: 12,
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
      backgroundColor: theme.colors.secondary,
    },
    toolbarRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing.sm,
    },
    toolbarIcons: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    iconButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing.xs,
    },
    sendButton: {
      width: 44,
      height: 44,
      borderRadius: 22,
      backgroundColor: theme.colors.primary,
      borderWidth: 1.5,
      borderColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    actionsContainer: {
      alignSelf: 'flex-start',
    },
  })